import { render, staticRenderFns } from "./SearchPasswordModule.vue?vue&type=template&id=481a716c&scoped=true"
import script from "./SearchPasswordModule.vue?vue&type=script&lang=js"
export * from "./SearchPasswordModule.vue?vue&type=script&lang=js"
import style0 from "./SearchPasswordModule.vue?vue&type=style&index=0&id=481a716c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a716c",
  null
  
)

export default component.exports